import { N10, N40 } from '@trello/colors';
import { TextDefaultColor, IconDefaultColor } from '@trello/nachos/tokens';
import { SharedState, useSharedState } from '@trello/shared-state';
import { BOARD_THEME_LIGHT } from './BoardTheme.types';
import type { BoardThemeVariables } from './BoardTheme.types';
import { getDynamicButtonBackgroundColors } from './getDynamicButtonBackgroundColors';
import { getDynamicNavItemBackgroundColors } from './getDynamicNavItemBackgroundColors';

export const defaultTheme: BoardThemeVariables = {
  theme: BOARD_THEME_LIGHT,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- EXCEPTION
  dynamicBackgroundColor: N10,
  dynamicBackgroundColorTransparent: undefined,
  dynamicIconColor: IconDefaultColor,
  dynamicTextColor: TextDefaultColor,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- EXCEPTION
  dynamicTextColorTransparent: N40,
  // eslint-disable-next-line @trello/no-module-logic
  ...getDynamicButtonBackgroundColors('light', false),
  // eslint-disable-next-line @trello/no-module-logic
  ...getDynamicNavItemBackgroundColors('light', false),
};

const boardThemeVariables = new SharedState<BoardThemeVariables>(defaultTheme);

export const useBoardThemeVariables = () => useSharedState(boardThemeVariables);
